import { Box } from '@mui/material'
import styled from 'styled-components'

export const TabOptionsContainer = styled(Box)`
  background-color: white;
  z-index: 10;
`
